/**
 * The access token is kept in memory only, so it dies with the tab.
 * The refresh token has to survive a reload, so it lives in localStorage —
 * a deliberate trade-off (see docs/DECISIONS.md, D12): a httpOnly cookie would
 * resist XSS better but needs CSRF protection, and the panel is internal-only.
 */
const REFRESH_KEY = 'fdt.refreshToken';

let accessToken: string | null = null;

export const tokenStorage = {
  getAccessToken: () => accessToken,
  setAccessToken(token: string | null) {
    accessToken = token;
  },

  getRefreshToken: () => localStorage.getItem(REFRESH_KEY),
  setRefreshToken(token: string | null) {
    if (token) {
      localStorage.setItem(REFRESH_KEY, token);
    } else {
      localStorage.removeItem(REFRESH_KEY);
    }
  },

  clear() {
    accessToken = null;
    localStorage.removeItem(REFRESH_KEY);
  },
};
